module.exports = __webpack_public_path__ + "static/media/ProximaNova-Extrabld.b0950a7a.ttf";